<svelte:head>

    <title>Profile • keyosh</title>

</svelte:head>

<script>

    import SessionManager from "../../components/utils/session.svelte";
    import Profile from "../../components/settings/profile.svelte";

</script>

<SessionManager />

<section>

    <Profile />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

</style>
